module.exports = __webpack_public_path__ + "img/all_mix_clip.2a276edc.jpg";